<template>
    <div>
        <div style="border-bottom: 1px solid #e7e5e5;line-height: 1.41176471;padding-bottom: 8px;">
     
            <font style="color: red;" v-if="tb.ismust">*</font>
             <font style="color: red;" v-else="tb.ismust">&nbsp </font>
             {{tb.name}}</div>
        <div style="height: 5px;"></div>
         
        <div>
            <a  @click = "test(1)" v-if="!kaiguan" class="weui-btn weui-btn_primary"><van-icon name="location-o"/>&nbsp;获取位置</a>
        </div>
        
        <div v-if = 'kaiguan' style="border: 1px solid rgb(143, 142, 142);
        color: #6e6e6e;
        display: flex;
        flex-direction: column;
        align-items: center;
                ">
        <div style="display: flex;
        width: 95%;
        ">       
           <div style="flex:1">
            <div>{{address?"":"正在获取中..."}}</div>
            <div>
                {{address}}
            </div>
            <div style="display: flex;justify-content: space-around;">
                <div>{{jingdu?"经度:"+jingdu:""}} </div>
                <div>{{weidu?" 纬度:"+weidu:""}}</div>
            </div>
           </div>
           <div style="height: 40px;width: 40px;
           display: flex;
           justify-content: center;
           align-items: center;
           ">
           
            <a @click="clear"><i class="weui-icon-clear"></i></a>   
        </div>
            
        </div>   
        <div style="height: 10px;"></div>
           <a class = "weui-btn  weui-btn_primary"
           @click = "test(2)"
           style="width: 95%;
           background-color: #bbbaba;
           color: #6e6e6e;
           ">{{address?"重新获取当前位置":"正在获取中..."}}</a>
           <div style="height: 10px;"></div>
        </div>

<br>
    </div>
</template>


<script>
    import Vue from 'vue';
import { Icon } from 'vant';

Vue.use(Icon);
export default{
    props:['tb'],
    data(){
        return{
            kaiguan:false,
            geolocation:null,
            address:"",
            jingdu:"",
            weidu:""
        }
    },
    watch:{
        jingdu(n,o){
                      
            if(this.address&&this.jingdu&&this.weidu){
                this.tb.val = "地址:"+this.address+"|经度:"+this.jingdu+"|纬度:"+this.weidu;
            }
            
            
        }
    },
    methods:{
        clear(){
           this.kaiguan = !this.kaiguan;
           
           this.address = "";
           this.jingdu = "";
           this.weidu = "";
           this.tb.val = ""; 
        },
        test(m){
            this.address = "";
           this.jingdu = "";
           this.weidu = "";
            if(m==1){this.kaiguan = !this.kaiguan;}
           
            this.geolocation.getCurrentPosition((status,result)=>{            
            if(status=='complete'){
               this.onComplete(result)
            }else{
                onError(result)
            }
        });

         function onError(x){
        weui.alert("获取定位失败");
    }
        
        },
        onComplete(x){
            // console.log(x);
            // console.log(x.formattedAddress);  
            this.address = x.formattedAddress;          
            // console.log('经度：'+x.position.lng);
            this.jingdu = x.position.lng;
            // console.log('纬度：'+x.position.lat);
            this.weidu = x.position.lat
        
          }

    },
    created(){
    AMap.plugin('AMap.Geolocation', ()=> {
         this.geolocation = new AMap.Geolocation({
            enableHighAccuracy: true,//是否使用高精度定位，默认:true
            timeout: 10000,          //超过10秒后停止定位，默认：5s
            buttonPosition:'RB',    //定位按钮的停靠位置
            buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            zoomToAccuracy: false,   //定位成功后是否自动调整地图视野到定位点
        }); 

    })





    }
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/fields/GetLocation.vue